import { useEffect } from "react";
import { useNavigate, useLocation, Routes, Route, useParams } from "react-router-dom";
import {
  ArrowLeft,
  Calendar,
  User,
} from "lucide-react";
import {
  // experiencesByCompany,
  // skills,
  // additionalSkills,
  // projects,
  // notableProjects,
  blogPosts,
} from "./components/helper";
import "./App.css";

import NewHeader from "./components/NewHeader";
import NewFooter from "./components/NewFooter";
import NewHome from "./components/NewHome";
import NewExperience from "./components/NewExperience";
import NewProjects from "./components/NewProjects";
import NewAIInnovation from "./components/NewAIInnovation";
import NewAbout from "./components/NewAbout";
import NewBlog from "./components/NewBlog";
import Contact from "./components/NewContact";

// const TAB_TO_PATH = {
//   // about: "/about",
//   experience: "/experience",
//   // skills: "/skills",
//   projects: "/projects",
//   contact: "/contact",
//   "about-dk": "/about",
//   blog: "/blog",
// };

// const PATH_TO_TAB = Object.fromEntries(
//   Object.entries(TAB_TO_PATH).map(([k, v]) => [v, k])
// );


const App = () => {
  // const navigate = useNavigate();
  // const location = useLocation();
  // const [activeCompany, setActiveCompany] = useState("Applab");

  // const currentPath = location.pathname;
  // const activeTab = PATH_TO_TAB[currentPath] || "about";

  // const companies = Object.keys(experiencesByCompany);
  // const companyExperiences = experiencesByCompany[activeCompany];

  // const handleTabClick = (tab) => {
  //   navigate(TAB_TO_PATH[tab]);
  // };

  return (
    <div className="min-h-screen flex flex-col relative bg-background">
      <ScrollToTop />
      <NewHeader />

      <div className="flex-1 w-full flex flex-col">
        <Routes>
          <Route path="/" element={<NewHome />} />

          <Route path="/experience" element={<NewExperience />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="/projects" element={<NewProjects />} />
          <Route path="/ai" element={<NewAIInnovation />} />

          <Route path="/about" element={<NewAbout />} />

          <Route path="/blog" element={<NewBlog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
        </Routes>
      </div>

      <NewFooter />
    </div>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const BlogPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const post = blogPosts.find((p) => p.id === id);

  if (!post) {
    return (
      <div className="text-center py-20">
        <h2 className="text-2xl text-white mb-4">Post not found</h2>
        <button
          onClick={() => navigate("/blog")}
          className="text-blue-400 hover:underline flex items-center justify-center mx-auto"
        >
          <ArrowLeft size={16} className="mr-2" /> Back to Blog
        </button>
      </div>
    );
  }

  return (
    <div className="glass-panel p-10 rounded-xl mt-32 max-w-container-max mx-auto mb-stack-lg w-full">
      <button
        onClick={() => navigate("/blog")}
        className="text-blue-400 hover:underline flex items-center mb-6"
      >
        <ArrowLeft size={16} className="mr-2" /> Back to Blog
      </button>

      <div className="mb-8">
        <div className="flex items-center text-sm text-blue-400 mb-2 space-x-4">
          <span className="flex items-center">
            <Calendar size={14} className="mr-1" />
            {post.date}
          </span>
          <span className="flex items-center">
            <User size={14} className="mr-1" />
            Dineshkumar Nataraj
          </span>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {post.title}
        </h1>
        <p className="text-xl text-blue-300 italic">{post.desc}</p>
      </div>

      <div
        className="prose prose-invert max-w-none text-gray-300 space-y-4 blog-content"
        dangerouslySetInnerHTML={{ __html: post.content }}
      />
    </div>
  );
};

export default App;